export const rejectAgreementInitialValues = () => ({
  reason: '',
});
